module.exports = __webpack_public_path__ + "img/zsgc32.219eaf0f.svg";